import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=3a526ac5&"
import script from "./AdminAdd.vue?vue&type=script&lang=js&"
export * from "./AdminAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports